import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSignOut } from "react-auth-kit";

// Shown when the server reports that the signed-in user's permissions changed
// (stale JWT after an admin updated their plan/role). The JWT lives in the
// _auth cookie and only a fresh /login mints a new one, so a page refresh can't
// recover — the user must log in again. apiService latches all further requests
// off when this happens (no loop, no AI cost); this modal turns that into a
// calm, user-triggered re-login instead of an abrupt forced logout.
//
// Non-dismissible on purpose: nothing in the app works until re-login, so the
// only action is the button (which the user clicks — never auto-fired).
export const SessionExpiredNotice = () => {
  const [show, setShow] = useState(false);
  const signOut = useSignOut();

  useEffect(() => {
    const onChanged = () => setShow(true);
    window.addEventListener("permissions-changed", onChanged);
    return () => window.removeEventListener("permissions-changed", onChanged);
  }, []);

  const handleRelogin = () => {
    // Clear the auth cookie first, then a full-page navigation to /login. The
    // full reload resets the apiService request latch and guarantees a clean
    // post-login state; with the cookie gone, RedirectIfAuth keeps the user on
    // /login (no loop).
    signOut();
    window.location.href = "/login?reason=permissions_changed";
  };

  return (
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Behörigheter uppdaterade</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Ditt konto har uppdaterats (t.ex. ändrad plan eller roll). Du behöver
          logga in igen för att fortsätta.
        </p>
        <p className="text-muted mb-0">
          En siduppdatering räcker inte — dina nya behörigheter hämtas först vid
          ny inloggning.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleRelogin}>
          Logga in igen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
